import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { Icon } from 'modules/common/components';
import { SortableWrapper, SortItem, DragHandler } from '../styles/sort';
import { reorder } from '../utils';
import EmptyState from './EmptyState';

const propTypes = {
  fields: PropTypes.array,
  child: PropTypes.func,
  onChangeFields: PropTypes.func,
  isModal: PropTypes.bool,
  zIndex: PropTypes.string,
  showDragHandler: PropTypes.bool
};

const defaultProps = {
  showDragHandler: true
};

class SortableListWithTwoInputs extends Component {
  constructor(props) {
    super(props);

    this.onDragEnd = this.onDragEnd.bind(this);
  }

  onDragEnd(result) {
    const { destination, source } = result;

    // dropped outside the list
    if (!destination) return;

    if (destination.index === source.index) {
      return;
    }

    const { fields, onChangeFields } = this.props;

    const reorderedFields = reorder(fields, source.index, destination.index);

    onChangeFields(reorderedFields);
  }

  renderDragHandler() {
    if (!this.props.showDragHandler) return;

    return (
      <DragHandler className='drag-handler'>
        <Icon icon="move" style={{
          fontSize: "18px",
          color: "#D9D9D9"
        }} />
      </DragHandler>
    );
  }

  renderField(field, index) {
    const { child, isModal, isDragDisabled = false } = this.props;

    return (
      <Draggable isDragDisabled={isDragDisabled} draggableId={field._id} index={index} key={index}>
        {(provided, snapshot) => (
          <Fragment>
            <SortItem
              className='sort-item'
              innerRef={provided.innerRef}
              {...provided.draggableProps}
              {...provided.dragHandleProps}
              isDragging={snapshot.isDragging}
              isModal={isModal}
              zIndex={this.props.zIndex}
            >
              {this.renderDragHandler()}

              {child(field)}
            </SortItem>
            {provided.placeholder}
          </Fragment>
        )}
      </Draggable>
    );
  }

  renderFields(provided) {
    const { fields } = this.props;

    if (fields && typeof fields === 'object' && fields.length > 0) {
      return (
        <SortableWrapper className='sortable-wrapper' innerRef={provided.innerRef}>
          {fields.map((field, index) => (<div className='sort-div d-flex align-items-center mb-4'>
            <span className='sort-span'>
              {index + 1}
            </span>
            {this.renderField(field, index)}
          </div>
          ))}
        </SortableWrapper>
      );
    } else {
      return <SortableWrapper innerRef={provided.innerRef}></SortableWrapper>;
    }
  }

  render() {
    if (this.props.fields.length === 0) {
      return <EmptyState text="There is no data" icon="ban" />;
    } else {
      return (
        <DragDropContext onDragEnd={this.onDragEnd}>
          <Droppable droppableId="droppableId" type="ITEMS">
            {provided => this.renderFields(provided)}
          </Droppable>
        </DragDropContext>
      );
    }
  }
}

SortableListWithTwoInputs.propTypes = propTypes;
SortableListWithTwoInputs.defaultProps = defaultProps;

export default SortableListWithTwoInputs;



// WEBPACK FOOTER //
// src/modules/theme/theme1/common/components/SortableListWithTwoInputs.jsx